import { Controller } from 'react-hook-form';
import { InputText } from '@ui/src';
import { ItemFormFlexInputsTypes } from './types';

import cn from './form.module.css';

const ItemFormFlexInputs = ({
  control,
  errorFrom,
  errorTo,
  title,
  nameFrom,
  nameTo,
  disabled,
  baseCurrency,
  currencyId,
  currencies,
  currenciesList,
}: ItemFormFlexInputsTypes) => (
  <div className={cn.itemFormFlexWrapper}>
    <div className={cn.itemFormFlexTitle}>{title}</div>
    <div className={cn.itemFormFlexContent}>
      <div className={cn.itemFormFlexInput}>
        <Controller
          control={control}
          name={nameFrom}
          defaultValue=""
          render={({ field: { onChange, value } }) => (
            <InputText
              name={nameFrom}
              placeholder="Enter value"
              onChange={onChange}
              value={value}
              error={errorFrom}
              prefix="From"
              suffix={
                currencies?.find((item) => item.value === currencyId)?.name ||
                baseCurrency?.name
              }
              labelClassName={`${cn.itemFormInputLabel} ${
                disabled ? cn.itemFormInputLabelDisabled : ''
              }`}
              disabled={disabled}
              tabIndex={disabled ? -1 : 0}
              currency={
                currenciesList?.find((item) => item.id === currencyId) ||
                baseCurrency
              }
              amountInput
            />
          )}
        />
      </div>
      <div className={cn.itemFormFlexInput}>
        <Controller
          control={control}
          name={nameTo}
          defaultValue=""
          render={({ field: { onChange, value } }) => (
            <InputText
              name={nameFrom}
              placeholder="Enter value"
              onChange={onChange}
              value={value}
              error={errorTo}
              prefix="To"
              suffix={
                currencies?.find((item) => item.value === currencyId)?.name ||
                baseCurrency?.name
              }
              labelClassName={`${cn.itemFormInputLabel} ${
                cn.itemFormInputLabelTo
              } ${disabled ? cn.itemFormInputLabelDisabled : ''}`}
              disabled={disabled}
              tabIndex={disabled ? -1 : 0}
              currency={
                currenciesList?.find((item) => item.id === currencyId) ||
                baseCurrency
              }
              amountInput
            />
          )}
        />
      </div>
    </div>
  </div>
);

export default ItemFormFlexInputs;
